import { Box, Typography } from '@material-ui/core'

import { Classification, LayerValueFailure } from '@/types/weed-diagnosis'

import { useStyles } from './styles'

export interface SummaryTableProps {
  summary:
    | {
        classifications: Classification[]
        length_fails: LayerValueFailure
        length_lines: LayerValueFailure
      }
    | undefined
}

export function SummaryTable({ summary }: SummaryTableProps) {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <header>
        <Typography variant='h3'>Dados de plantio</Typography>
      </header>

      <table className={classes.summaryTable}>
        <thead>
          <tr>
            <th>&bull;</th>
            <th>Linhas de plantio</th>
            <th>{((summary?.length_lines.length || 0) * 1000).toFixed(2)} m</th>
            <th>({summary?.length_lines.pc.toFixed(2)}%)</th>
          </tr>
        </thead>
        <thead>
          <tr>
            <th>&bull;</th>
            <th>Falhas de plantio</th>
            <th>{((summary?.length_fails.length || 0) * 1000).toFixed(2)} m</th>
            <th>({summary?.length_fails.pc.toFixed(2)}%)</th>
          </tr>
        </thead>
        <thead className={classes.classifications}>
          <tr>
            <th></th>
            <th>Classificação das falhas:</th>
            <th></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {summary?.classifications.map((classification) => (
            <tr key={classification.color}>
              <td>
                <Box
                  bgcolor={classification.color}
                  minWidth={16}
                  minHeight={4}
                  maxWidth={16}
                  maxHeight={4}
                  borderRadius={1}
                  marginTop='1px'
                  marginY='auto'
                />
              </td>
              <td>
                <span>
                  {classification.failure_range.at(1)
                    ? `De ${classification.failure_range.at(0)?.toFixed(1)} à
                  ${classification.failure_range.at(1)?.toFixed(1)} m`
                    : `Acima de ${classification.failure_range
                        .at(0)
                        ?.toFixed(1)} m`}
                </span>
              </td>
              <td>{((classification.length || 0) * 1000).toFixed(2)} m</td>
              <td>({classification.pc.toFixed(2)}%)</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
